//# sourceMappingURL=my-weekday.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-mydatepicker/dist/interfaces/my-weekday.interface.js
// module id = 575
// module chunks = 10